function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import colors from "/styles/colors";
import PictureComponent from "/components/core/picture/picture-component";
import { trackEvent } from "services/bigbrain-service";
import { THUMBNAIL_LIST_LINK_CLICKED, THUMBNAIL_LIST_BOTTOM_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { StyledBackgroundImageThumbnailItemComponent } from "./background-image-thumbnail-item-component.scss";
class BackgroundImageThumbnailItemComponent extends PureComponent {
    onButtomLinkClick(e) {
        const { buttomLink } = this.props;
        trackEvent(THUMBNAIL_LIST_BOTTOM_LINK_CLICKED, {
            kind: buttomLink
        });
        e.stopPropagation();
        e.preventDefault();
        window.location.href = buttomLink.url;
    }
    shouldShowHoverDecorator() {
        const { hoverDecorator } = this.props;
        return hoverDecorator && hoverDecorator.show;
    }
    shouldShowButtomLink() {
        const { buttomLink } = this.props;
        return buttomLink && buttomLink.show;
    }
    shouldShowSecondTitle() {
        const { secondTitle } = this.props;
        return secondTitle && secondTitle.text && secondTitle.text.length > 0;
    }
    renderTitle(title) {
        const { text, decorator } = title;
        return /*#__PURE__*/ _jsxs("div", {
            className: "thumbnail-title",
            children: [
                text,
                " ",
                /*#__PURE__*/ _jsx("span", {
                    className: "thumbnail-title-decorator",
                    children: decorator
                })
            ]
        });
    }
    render() {
        const { link, firstTitle, secondTitle, subtitle, buttomLink, image, hoverDecorator } = this.props;
        return /*#__PURE__*/ _jsxs(StyledBackgroundImageThumbnailItemComponent, {
            className: classnames("background-image-thumbnail-item-component", {
                "extended-hover-height": this.shouldShowSecondTitle()
            }),
            href: link,
            target: "_blank",
            onClick: this.itemClicked,
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "image-container",
                    src: image,
                    extraCloudinaryTransformations: {
                        width: 400
                    }
                }),
                this.shouldShowHoverDecorator() && /*#__PURE__*/ _jsx("div", {
                    className: "hover-decorator-container",
                    children: hoverDecorator.text
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-container",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "thumbnail-title-wrapper",
                            children: [
                                this.renderTitle(firstTitle),
                                this.shouldShowSecondTitle() && this.renderTitle(secondTitle)
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "thumbnail-subtitle",
                            children: subtitle
                        }),
                        this.shouldShowButtomLink() && /*#__PURE__*/ _jsx("div", {
                            className: "buttom-link-container",
                            onClick: this.onButtomLinkClick,
                            style: {
                                color: colors[buttomLink.color]
                            },
                            children: buttomLink.text
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "itemClicked", ()=>{
            const { link } = this.props;
            trackEvent(THUMBNAIL_LIST_LINK_CLICKED, {
                kind: link
            });
        });
        this.onButtomLinkClick = this.onButtomLinkClick.bind(this);
    }
}
export { BackgroundImageThumbnailItemComponent as default };
BackgroundImageThumbnailItemComponent.defaultProps = {
    firstTitle: {}
};
